import React, { useState, useEffect } from "react";
import {
  Row,
  Space,
  Form,
  Input,
  Alert,
  Typography,
  Button,
  Select,
  Spin,
} from "antd";
import { postAPI, getAPI } from "../../../config/api/apiConfig";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

const { Title } = Typography;
const { Option } = Select;

const RegisterDevice = () => {
  const [isChecking, setIsChecking] = useState(false);
  const [isExisting, setIsExisting] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(true);
  const [isUserAdded, setIsUserAdded] = useState(false);
  const [isUserNotAdded, setIsUserNotAdded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [isShow, setIsShow] = useState(true);

  const checkOrganisations = () => {
    console.log("input", inputValue);
    setIsChecking(true);
    getAPI(`get-organisations-by-name/${inputValue.trim()}`, token)
      .then((response) => {
        console.log("RES", response);
        const { data } = response.data;
        if (data.length === 0) {
          setIsChecking(false);
          setIsSubmitting(false);
          setIsExisting(false);
        } else {
          setIsExisting(true);
          setIsSubmitting(true);
          setIsChecking(false);
        }
      })

      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
        setIsSubmitting(false);
      });
  };

  const history = useHistory();
  const dispatch = useDispatch();
  const role = useSelector((state) => state.authenticate.role);
  const createdBy = useSelector((state) => state.authenticate.createdBy);
  const token = useSelector((state) => state.authenticate.userToken);
  const [form] = Form.useForm();

  const addUser = async (values) => {
    console.log(values);
    setIsShow(false);
    setLoading(true);

    //create-azure-guest-user
    try {
      let url;
      if (role === "Nibss_Super_Cert01") {
        url = `/create-azure-user/${parseInt(createdBy, 10)}`;
      } else {
        url = `/create-azure-guest-user`;
      }

      console.log(token);
      const signIn = await postAPI(url, values, token);
      console.log(signIn.data);
      if (signIn.data.success) {
        setIsUserAdded(signIn.data.success);
        setMsg(signIn.data.message);
        setLoading(false);
        form.resetFields();
        setIsUserNotAdded(false);
      }
      setIsUserNotAdded(false);
    } catch (err) {
      console.log(err);
      setErrorMsg(err.response?.data?.msg);
      setLoading(false);
      setIsUserAdded(false);
      setIsUserNotAdded(true);
    }
    setIsShow(true)
    setTimeout(() => {
      setIsShow(false);
    }, 7000);
  };

  return (
    <Row
      style={{
        padding: 0,
        margin: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
      gutter={0}
    >
      <div className="row-nibss">
        {
          // this.routeParams
          <div className="device-form">
            <Space
              direction="vertical"
              style={{
                width: "100%",
              }}
            >
              {isUserAdded && isShow && (
                <Alert
                  message={isUserAdded ? msg : ""}
                  //description={msg}
                  type="success"
                  showIcon
                  closable
                />
              )}

              {isUserNotAdded && isShow && (
                <Alert
                  message={isUserNotAdded ? errorMsg : ""}
                  description={msg}
                  type="error"
                  showIcon
                  closable
                />
              )}

              {!isChecking && isExisting && isShow && (
                <Alert
                  message={"Organisation already exists"}
                  type="error"
                  showIcon
                  closable
                />
              )}
            </Space>

            <Form
              form={form}
              onFinish={addUser}
              // onFinishFailed={onFinishFailed}
              layout="vertical"
              className="row-col input-device"
            >
              <Form.Item
                className="form-item username "
                label="Email "
                name="username"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please input your email!",
                  },
                ]}
              >
                <Input placeholder="Enter Username" />
              </Form.Item>
              <Form.Item
                className="form-item  username "
                label="Password"
                name="password"
                style={{ display: "none" }}
                value="password"
                initialValue="password"
                rules={[
                  {
                    required: true,
                    message: "Please input Device Model",
                  },
                ]}
              >
                <Input placeholder="password" defaultValue="password" />
              </Form.Item>
              {role === "Nibss_Admin_Ticket" && (
                <>
                  <Form.Item
                    className="form-item  username "
                    label="First Name"
                    name="firstName"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter FirstName",
                      },
                    ]}
                  >
                    <Input placeholder="Please Enter FirstName" />
                  </Form.Item>
                  <Form.Item
                    className="form-item  username "
                    label="Last Name"
                    name="lastName"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter LastName",
                      },
                    ]}
                  >
                    <Input placeholder="Please Enter LastName" />
                  </Form.Item>
                  <Form.Item
                    className="form-item  username "
                    label="Job Title"
                    name="jobRole"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Job Title",
                      },
                    ]}
                  >
                    <Input placeholder="Please Enter  Job Title" />
                  </Form.Item>
                  <Form.Item
                    className="form-item  username "
                    label="Department"
                    name="dept"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Your Department",
                      },
                    ]}
                  >
                    <Input placeholder="Please Enter Your Department" />
                  </Form.Item>
                  <Form.Item
                    className="form-item  username "
                    label="Phone Number"
                    name="phoneNumber"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Phone Number",
                      },
                    ]}
                  >
                    <Input placeholder="Please Enter  Phone Number" />
                  </Form.Item>
                </>
              )}

              <Form.Item
                className="username form-item"
                label={
                  role === "Nibss_Super_Cert01"
                    ? "Admin Name"
                    : "Organisation Name"
                }
                name="organisationName"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: `${
                      role === "Nibss_Super_Cert01"
                        ? "Please input Admin Name"
                        : "Please input organisation Name"
                    }`,
                  },
                ]}
              >
                {isChecking && (
                  <p className="org-check">checking organisation name...</p>
                )}
                <Input
                  placeholder={
                    role === "Nibss_Super_Cert01"
                      ? "Add Admin Name"
                      : "Add Organisation Name"
                  }
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  onBlur={checkOrganisations}
                />
              </Form.Item>
              <Form.Item
                className="username input-device"
                label="Role"
                name="role"
                style={{ display: "none" }}
                value="role"
                initialValue="role"
                rules={[
                  {
                    required: true,
                    message: "Please input user role",
                  },
                ]}
              >
                <Input placeholder="Set user role" defaultValue="role" />
              </Form.Item>
              <Form.Item
                className="username input-device"
                label="Created By"
                name="createdBy"
                style={{ display: "none" }}
                value={createdBy}
                initialValue={createdBy}
              >
                <Input defaultValue={createdBy} />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "100%" }}
                  className="nibss-form-btn"
                  loading={loading}
                  disabled={isSubmitting}
                >
                  {role === "Nibss_Super_Cert01" ? "Add User" : "Add Vendor"}
                </Button>
              </Form.Item>
            </Form>
          </div>
        }
      </div>
    </Row>
  );
};

export default RegisterDevice;
